export enum StringOperators {
  CONTAINS = 'contains',
  DOES_NOT_CONTAIN = 'doesNotContain',
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  STARTS_WITH = 'startsWith',
  ENDS_WITH = 'endsWith',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
}

export enum NumberOperators {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  LESS_THAN = 'lessThan',
  LESS_THAN_OR_EQUAL = 'lessThanOrEqual',
  GREATER_THAN = 'greaterThan',
  GREATER_THAN_OR_EQUAL = 'greaterThanOrEqual',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
  ZERO = 'zero',
}

export enum DateOperators {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  BEFORE = 'before',
  AFTER = 'after',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
}

export enum BooleanOperators {
  IS_TRUE = 'isTrue',
  IS_FALSE = 'isFalse',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
}

export enum EnumOperators {
  EQUALS = 'equals',
  NOT_EQUALS = 'notEquals',
  SOME = 'some',
  IS_EMPTY = 'isEmpty',
  IS_NOT_EMPTY = 'isNotEmpty',
}
